import R from 'ramda'

const REACTION_DISPLAY_TYPE = 'Match Reaction'
const REACTION_TRIGGER_TYPE = 'REACTION'

const isReactionWidgetTrigger = R.propEq('type', REACTION_TRIGGER_TYPE)

const convertReactionWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(REACTION_DISPLAY_TYPE),
  value: R.prop('data')
})

export { isReactionWidgetTrigger, convertReactionWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/widget-to-form/reaction.js